import { RdiDocument } from './RdiDocument';
import { renderPdfWithAttachment } from '../renderPdfWithAttachment';
import type { RDIFormData, SectionToggles } from '../../clinical/types';

export function buildMergedRdiPdf(
    data: RDIFormData,
    attachment: File | null,
    hasOrthopulse: boolean,
    toggles: SectionToggles,
    attachmentBytes?: Uint8Array | null
): Promise<Blob> {
    return renderPdfWithAttachment(
        <RdiDocument data={data} hasOrthopulse={hasOrthopulse} toggles={toggles} />,
        attachment,
        attachmentBytes
    );
}
